<template>
  <div>
    <Row>
      <!-- <div class="workOrder_info">
        <div class="left title">
          当前状态：<span class="common_color">{{ this.info.patrolName }}</span>
        </div>
        <div class="right">
          <div class="title">维修员：<span class="common_color">张三</span></div>
          <div class="margin_middle title">派单方式：<span class="common_color">自动派单</span></div>
          <div class="title">报修时间：<span class="common_color">2020-10-02 09：00：26</span></div>
        </div>
      </div>
      <div class="workOrder_br"></div> -->
      <div class="workOrder_content">
        <div class="title">巡检信息</div>
        <Row style="margin-top: 20px">
          <Col span="3" :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <div class="common_title" style="margin-left: 15px">
              巡检名称：<span class="common_color">{{
                this.info.patrolName
              }}</span>
            </div>
          </Col>
          <Col span="3" :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <div class="common_title">
              负责人：<span class="common_color">{{ this.info.name }}</span>
            </div>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="3" :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <div class="common_title" style="margin-left: 15px">
              巡检目标：<span class="common_color">{{
                this.info.facilityListName
              }}</span>
            </div>
          </Col>
          <!-- <Col span="3" :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <div class="common_title">开始时间：<span class="common_color">3号楼25层201室</span></div>
          </Col> -->
        </Row>
        <!-- <Row>
          <Col span="3" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top:20px;display:flex">
            <div class="common_title" style="margin-left:15px">资产二维码：</div>
            <div class="common_image" style="margin-left:5px;margin-right:5px"></div>
          </Col>
        </Row> -->
      </div>
      <div class="workOrder_br"></div>
      <div class="workOrder_content">
        <div class="title">计划基本信息</div>
        <Row style="margin-top: 20px">
          <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title" style="margin-left: 15px">
              巡检编号：<span
                class="common_color"
                style="cursor: pointer"
                @click="copyText(info.status_name)"
                >25685544220</span
              >
            </div>
          </Col>
          <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title">
              巡检周期：<span
                class="common_color"
                v-if="this.info.timeUnit === 1"
                >{{ this.info.patrolInterval }}分钟</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 2"
                >{{ this.info.patrolInterval }}小时</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 3"
                >{{ this.info.patrolInterval }}天</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 4"
                >{{ this.info.patrolInterval }}周</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 5"
                >{{ this.info.patrolInterval }}月</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 6"
                >{{ this.info.patrolInterval }}季度</span
              >
              <span class="common_color" v-if="this.info.timeUnit === 7"
                >{{ this.info.patrolInterval }}年</span
              >
            </div>
          </Col>
          <!-- <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title">巡检内容：<span class="common_color">{{ this.info.patrolContent }}</span></div>
          </Col> -->
        </Row>
        <Row style="margin-top: 20px">
          <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title" style="margin-left: 15px">
              场景地址：<span class="common_color">{{
                this.info.sceneSite
              }}</span>
            </div>
          </Col>
          <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title">
              开始时间：<span class="common_color">{{
                this.info.patrolBeginTime
              }}</span>
            </div>
          </Col>
          <Col span="3" :xxl="8" :xl="8" :lg="8" :md="8" :sm="8" :xs="24">
            <div class="common_title">
              创建时间：<span class="common_color">{{
                this.info.createTime
              }}</span>
            </div>
          </Col>
        </Row>
        <!-- <Row>
          <Col span="3" :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top:20px;display:flex">
            <div class="common_title" style="margin-left:15px">维修照片：</div>
            <div class="common_image" style="margin-left:5px;margin-right:5px"></div>
          </Col>
        </Row> -->
        <Row>
          <Col
            span="3"
            :xxl="24"
            :xl="24"
            :lg="24"
            :md="24"
            :sm="24"
            :xs="24"
            style="margin-top: 20px; display: flex"
          >
            <div class="common_title" style="margin-left: 15px; width: 70px">
              巡检内容：
            </div>
            <div class="common_title">
              <span class="common_color">{{ this.info.patrolContent }}</span>
            </div>
          </Col>
        </Row>
      </div>
      <div class="workOrder_br"></div>
      <div class="workOrder_content">
        <div class="title">巡检记录</div>
        <div>
          <Table border :columns="columns1" :data="data1"></Table>
          <br />
          <Page
            :total="total"
            show-total
            @on-change="changePage"
            @on-page-size-change="changePagesize"
          />
        </div>
      </div>
    </Row>
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="imgUrl" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
import expandRow from "./table.vue";
import Clipboard from "clipboard";
export default {
  name: "Info",
  components: { expandRow },
  props: {
    kv: null,
    planId: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) {
      // this.initData(v)
    },
  },
  data() {
    return {
      mname: "patrol",
      url: {},
      items: [], // 显示条目
      info: {
        // status_name: '处理中',
      },
      imgUrl: "",
      imgVisible: false,
      list: [],
      //巡检列表
      columns1: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row.log,
              },
            });
          },
        },
        // {
        //     title: '巡检计划ID',
        //     minWidth: 100,
        //     key: 'planId',
        //     align: 'center',
        //   },
        {
          title: "巡检名称",
          key: "patrolName",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolName;
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "负责人",
          key: "maintainerName",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.maintainerName;
            return (
              <span
                style={{
                  color: row.row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检周期",
          key: "patrolInterval",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.timeUnit == 1
                ? row.patrolInterval + "分钟"
                : row.timeUnit == 2
                ? row.patrolInterval + "小时"
                : row.timeUnit == 3
                ? row.patrolInterval + "天"
                : row.timeUnit == 4
                ? row.patrolInterval + "周"
                : row.timeUnit == 5
                ? row.patrolInterval + "月"
                : row.timeUnit == 6
                ? row.patrolInterval + "季度"
                : row.timeUnit == 7
                ? row.patrolInterval + "年"
                : "";
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: "巡检资产",
        //   key: "facilityListName",
        //   minWidth: 120,
        //   align: "center",
        //   // viewimage: true,
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.facilityListName;
        //     return (
        //       <span
        //         style={{
        //           color: row.state == 3 ? "red" : "",
        //           "font-size": "14px",
        //         }}
        //       >
        //         {text}
        //       </span>
        //     );
        //   },
        // },
        {
          title: "巡检开始时间",
          minWidth: 170,
          align: "center",
          key: "patrolBeginTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolBeginTime;
            return (
              <span
                style={{
                  color: row.row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "备注信息",
          minWidth: 120,
          align: "center",
          key: "remark",
          render: (h, params) => {
            const row = params.row;
            const text = row.remark;
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "状态",
          minWidth: 120,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "未巡检"
                : row.state == 2
                ? "已巡检正常"
                : row.state == 3
                ? "过时未巡检"
                : row.state == 4
                ? "延期"
                : "";
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },

        {
          title: "提交时间",
          align: "center",
          width: 115,
          key: "updateTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.updateTime.slice(0, 16);
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
    if (query.planId) {
      this.planId = query.planId;
    }
    if (this.planId) {
      this.initData(this.planId);
    }
  },
  mounted() {
    if (this.planId) {
      this.load(this.planId);
    }
  },
  methods: {
    initItems() {
      return this.items;
    },
    async initData(planId, page = 1) {
      // 加载详情数据
      let d = {}
      d.id = this.kv;
      let res = await $utils.api.load(`/maintainer/maintainer/patrol/getInspect`, d)
        if (res && res.data) {
          this.info = res.data;
        }
      //转单记录
      let q = {};
      q.planId = planId;
      q.pageSize = 10;
      q.pageNum = page;
      q.orderByColumn = "updateTime";
      q.isAsc = "descending";
      let res1 = await $utils.api
        .load("/maintainer/maintainer/patrolLog/list", q)
      try {
          if (res1.code > 0) {
            let data = res1.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }

      }catch(e){
          $utils.toast.error("请求错误");
        }
    },
    async load(planId, page = 1) {
      let q = {};
      q.pageSize = 10;
      q.pageNum = page;
      q.planId = planId;
      let res = await $utils.api
        .load("/maintainer/maintainer/patrolLog/list", q)
        try {

          if (res.code > 0) {
            let data = res.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }

        } catch(e){
          $utils.toast.error("请求错误");
        }
    },
    changePage(p) {
      // let planId = this.planId
      this.load(this.planId, p);
    },
    showImg(src) {
      this.imgUrl = src;
      this.imgVisible = true;
    },
    copyText(val) {
      let clipboard = new Clipboard("." + val);
      this.$Message.info("已复制 " + val);
    },
  },
};
</script>
<style lang="less" scoped>
.workOrder_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  height: 60px;
  border-radius: 5px;
  .left {
    margin-left: 40px;
  }
  .right {
    display: flex;
    align-items: center;
    margin-right: 45px;
    .margin_middle {
      margin-left: 90px;
      margin-right: 30px;
    }
  }
  .title {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}
.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;
  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }
  .item_box {
    display: flex;
  }
}
.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}
.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}
.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}
.common_color {
  color: #666;
}
</style>
